import { retryFetch } from './RetryHelper';
import { debug } from 'src/logger';
import initialMetricsPublisher from "src/metrics";

interface NotifyNewIntakeRequest {
    transaction_id: string;
    reporting_id?: string;
}

interface NotifyNewIntakeResponse {
    outcome: string;
}

export const notifyNewIntake =
    async (params: NotifyNewIntakeRequest): Promise<NotifyNewIntakeResponse> => {
        try {
            return await retryFetch(async () => {
                debug('Making NotifyNewIntake Request:', params);
                const response = await fetch('/getstarted/api/notifyNewIntakeId', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(params)
                });
                if (!response.ok) {
                    if (response.status === 429) {
                        const actionMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod('NotifyNewIntakeCall');
                        actionMetricsPublisher.publishCounterMonitor('MonsServiceRateLimitCount', 1);
                    }
                    throw new Error('Encountered exception when calling NotifyNewIntake')
                }

                const data = await response.json();
                debug('Received NotifyNewIntake Response:', data);

                return {
                    outcome: data.outcome
                };
            });
        } catch (error) {
            console.error('Encountered exception calling NotifyNewIntake');
            return { outcome: ''};
        }
    }
